/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { EquipementDto } from '../models/equipement-dto';
import { EquipementEnergyDto } from '../models/equipement-energy-dto';
import { EquipementRegistreDto } from '../models/equipement-registre-dto';
import { getEquipementById } from '../fn/equipement-controller/get-equipement-by-id';
import { GetEquipementById$Params } from '../fn/equipement-controller/get-equipement-by-id';
import { getEquipementRegistres } from '../fn/equipement-controller/get-equipement-registres';
import { GetEquipementRegistres$Params } from '../fn/equipement-controller/get-equipement-registres';
import { getEquipementsByQrCode } from '../fn/equipement-controller/get-equipements-by-qr-code';
import { GetEquipementsByQrCode$Params } from '../fn/equipement-controller/get-equipements-by-qr-code';
import { getEquipementsBySite } from '../fn/equipement-controller/get-equipements-by-site';
import { GetEquipementsBySite$Params } from '../fn/equipement-controller/get-equipements-by-site';
import { getEquipementsEnergies } from '../fn/equipement-controller/get-equipements-energies';
import { GetEquipementsEnergies$Params } from '../fn/equipement-controller/get-equipements-energies';
import { patchEquipement } from '../fn/equipement-controller/patch-equipement';
import { PatchEquipement$Params } from '../fn/equipement-controller/patch-equipement';
import { upsertEquipementQrCode } from '../fn/equipement-controller/upsert-equipement-qr-code';
import { UpsertEquipementQrCode$Params } from '../fn/equipement-controller/upsert-equipement-qr-code';

/**
 * Récupérer les équipements energie.
 */
@Injectable({ providedIn: 'root' })
export class EquipementControllerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `patchEquipement()` */
  static readonly PatchEquipementPath = '/v1/equipements';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchEquipement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchEquipement$Response(
    params: PatchEquipement$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    return patchEquipement(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchEquipement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchEquipement(params: PatchEquipement$Params, context?: HttpContext): Observable<void> {
    return this.patchEquipement$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `upsertEquipementQrCode()` */
  static readonly UpsertEquipementQrCodePath = '/v1/equipements/qrCode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertEquipementQrCode()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertEquipementQrCode$Response(
    params: UpsertEquipementQrCode$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<{}>> {
    return upsertEquipementQrCode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upsertEquipementQrCode$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertEquipementQrCode(params: UpsertEquipementQrCode$Params, context?: HttpContext): Observable<{}> {
    return this.upsertEquipementQrCode$Response(params, context).pipe(map((r: StrictHttpResponse<{}>): {} => r.body));
  }

  /** Path part for operation `getEquipementById()` */
  static readonly GetEquipementByIdPath = '/v1/equipements/{idEquipement}';

  /**
   * get.
   *
   * Récupérer un équipement par son id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEquipementById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEquipementById$Response(
    params: GetEquipementById$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<EquipementDto>> {
    return getEquipementById(this.http, this.rootUrl, params, context);
  }

  /**
   * get.
   *
   * Récupérer un équipement par son id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEquipementById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEquipementById(params: GetEquipementById$Params, context?: HttpContext): Observable<EquipementDto> {
    return this.getEquipementById$Response(params, context).pipe(
      map((r: StrictHttpResponse<EquipementDto>): EquipementDto => r.body)
    );
  }

  /** Path part for operation `getEquipementRegistres()` */
  static readonly GetEquipementRegistresPath = '/v1/equipements/{idEquipement}/equipement_registres';

  /**
   * get.
   *
   * récupérer les équipements registres d'un équipement particulier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEquipementRegistres()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEquipementRegistres$Response(
    params: GetEquipementRegistres$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<EquipementRegistreDto>>> {
    return getEquipementRegistres(this.http, this.rootUrl, params, context);
  }

  /**
   * get.
   *
   * récupérer les équipements registres d'un équipement particulier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEquipementRegistres$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEquipementRegistres(
    params: GetEquipementRegistres$Params,
    context?: HttpContext
  ): Observable<Array<EquipementRegistreDto>> {
    return this.getEquipementRegistres$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EquipementRegistreDto>>): Array<EquipementRegistreDto> => r.body)
    );
  }

  /** Path part for operation `getEquipementsEnergies()` */
  static readonly GetEquipementsEnergiesPath = '/v1/equipements/{idEquipement}/equipement_energies';

  /**
   * get.
   *
   * récupérer les équipements energies
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEquipementsEnergies()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEquipementsEnergies$Response(
    params: GetEquipementsEnergies$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<EquipementEnergyDto>>> {
    return getEquipementsEnergies(this.http, this.rootUrl, params, context);
  }

  /**
   * get.
   *
   * récupérer les équipements energies
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEquipementsEnergies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEquipementsEnergies(
    params: GetEquipementsEnergies$Params,
    context?: HttpContext
  ): Observable<Array<EquipementEnergyDto>> {
    return this.getEquipementsEnergies$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EquipementEnergyDto>>): Array<EquipementEnergyDto> => r.body)
    );
  }

  /** Path part for operation `getEquipementsBySite()` */
  static readonly GetEquipementsBySitePath = '/v1/equipements/bySite';

  /**
   * get.
   *
   * Récupérer des équipements
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEquipementsBySite()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEquipementsBySite$Response(
    params?: GetEquipementsBySite$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<EquipementDto>>> {
    return getEquipementsBySite(this.http, this.rootUrl, params, context);
  }

  /**
   * get.
   *
   * Récupérer des équipements
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEquipementsBySite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEquipementsBySite(params?: GetEquipementsBySite$Params, context?: HttpContext): Observable<Array<EquipementDto>> {
    return this.getEquipementsBySite$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EquipementDto>>): Array<EquipementDto> => r.body)
    );
  }

  /** Path part for operation `getEquipementsByQrCode()` */
  static readonly GetEquipementsByQrCodePath = '/v1/equipements/byQrCode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEquipementsByQrCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEquipementsByQrCode$Response(
    params: GetEquipementsByQrCode$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<EquipementDto>> {
    return getEquipementsByQrCode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEquipementsByQrCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEquipementsByQrCode(params: GetEquipementsByQrCode$Params, context?: HttpContext): Observable<EquipementDto> {
    return this.getEquipementsByQrCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<EquipementDto>): EquipementDto => r.body)
    );
  }
}
